import { styled } from "styled-components";

export const Card = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #e5e7eb;

  &:hover {
    background-color: #f9fafb;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const InvoiceInfo = styled.div``;

export const InvoiceTitle = styled.h4`
  font-weight: 500;
  font-size: 16px;
  color: #111827;
  margin: 0 0 4px 0;
`;

export const InvoiceTotal = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;

export const InvoiceServiceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  p {
    margin: 0;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #6b7280;
  }

  span {
    display: flex;
    align-items: center;
  }
`;

export const Content = styled.div`
  padding: 16px;
  padding-top: 0;
`;

export const Separator = styled.div`
  height: 1px;
  background-color: #e5e7eb;
  margin-bottom: 12px;
`;

export const TariffList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InvoiceBadge = styled.span<{ status: string }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ status }) => {
    switch (status) {
      case "OPEN":
        return "#1e7e34";
      case "CLOSED":
        return "#a71d2a";
      case "CANCELED":
        return "#b35600";
      default:
        return "#374151";
    }
  }};
  background-color: ${({ status }) => {
    switch (status) {
      case "OPEN":
        return "rgba(40, 167, 69, 0.1)";
      case "CLOSED":
        return "rgba(220, 53, 69, 0.1)";
      case "CANCELED":
        return "rgba(253, 126, 20, 0.1)";
      default:
        return "rgba(107, 114, 128, 0.1)";
    }
  }};
  border: 1px solid
    ${({ status }) => {
      switch (status) {
        case "OPEN":
          return "#28a745";
        case "CLOSED":
          return "#dc3545";
        case "CANCELED":
          return "#fd7e14";
        default:
          return "#6b7280";
      }
    }};
`;

export const ChevronAndBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
